<template>

  <b-dropdown :html="html" variant="outline-primary" block :key="instanceId">
      <b-dropdown-item @click.capture="val = true">
        <div class="d-flex align-items-center">
          <input type="radio" :checked="val === true" class="mr-1"/> Ja
        </div>
      </b-dropdown-item>
      <b-dropdown-item @click.capture="val = false">
        <div class="d-flex align-items-center">
          <input type="radio" :checked="val === false" class="mr-1"/> Nee
        </div>
      </b-dropdown-item>
      <b-dropdown-item @click.capture="val = undefined">
        <div class="d-flex align-items-center">
          <input type="radio" :checked="val === undefined" class="mr-1"/> Eender welke
        </div>
      </b-dropdown-item>
  </b-dropdown>

</template>

<script>
import uniqueId from 'lodash/uniqueId';

export default
{
    computed:
    {
        val:
        {
            get() { return this.value; },
            set(v)
            {
                this.instanceId = uniqueId('v_');
                this.$emit('input', v);
            }
        },
        html()
        {
            switch (this.value)
            {
                case true: return 'J';
                case false: return 'N';
                case undefined: return 'J&N'
                default: return 'J&N'
            }
        }
    },
    data()
    {
        return {
            instanceId: uniqueId('v_')
        }
    },
    props:
    {
        value: { }
    }
}
</script>

<style>
</style>